import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTagInput from "components/SuiTagInput";
import SuiDatePicker from "components/SuiDatePicker";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";
import ScheduleIcon from "@mui/icons-material/Schedule";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";
import InsertInvitationOutlinedIcon from "@mui/icons-material/InsertInvitationOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";

import api from "services/api";
import moment from "moment";

import { DatePicker, Upload } from "antd";
import Prompt from "components/UpStyled/Prompt";
import ColorDropDownMenu from "pages/calendar/components/ColorDropDownMenu";

import { filterParser } from "utils/helper";
import { colorOptions } from "utils/data";

import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

const ImportCalendarFileModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      calendarOptions = [],
      handleRefresh = () => {},
      handleAfterOk = () => {},
      refreshDelay = 0,
    },
    ref
  ) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedCalendar, setSelectedCalendar] = useState(calendarOptions?.[0]);

    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
    };

    const account = useContext(AccountContext);

    const handleImportCalendar = async () => {
      try {
        console.log(selectedCalendar);

        const imported = await api.calendar.importCalendar(selectedCalendar?.value, selectedFile);
        console.log(imported);
        toast.success(`Import events successfully!`);

        handleClose();
        handleAfterOk(imported);

        setTimeout(() => {
          handleRefresh();
        }, refreshDelay);
      } catch (err) {
        console.log(err);
        toast.error(`Import events failed!`);
      }
    };

    return (
      <Dialog
        open={visible}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          {"Import events"}

          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <SuiBox>
              <input type="file" id="docpicker" accept=".ics" onChange={handleFileChange} />
            </SuiBox>
            <SuiBox>
              <SuiSelect
                value={selectedCalendar}
                onChange={(option) => setSelectedCalendar(option)}
                options={calendarOptions}
                placeholder="Add to calendar"
                backspaceRemovesValue
              />
            </SuiBox>
            <SuiBox
              pt={3}
              px={3}
              display="flex"
              justifyContent="space-between"
              alignItems={"center"}
              gap={1}
            >
              <SuiBox></SuiBox>
              <SuiBox display="flex" gap={1} alignItems="center" justifyContent="end">
                <SuiButton
                  size="medium"
                  variant="gradient"
                  color="dark"
                  onClick={handleImportCalendar}
                >
                  Import
                </SuiButton>
              </SuiBox>
            </SuiBox>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
);

export default ImportCalendarFileModal;
